import { TextInput, Typography } from "@strapi/design-system";
import { useTranslation } from "react-i18next";
import DegreeSelect from "../degreeSelect";
import UploadFile from "../uploadFile";
import { useState, useEffect } from "react";

const ThesisMember = ({ data, setData }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (data?.attachment) {
      let item = null;

      if (data?.attachment?.id) {
        item = {
          uid: data?.attachment?.id,
          name: data?.attachment?.name,
          url: data?.attachment?.url,
          status: "done",
        };
      } else {
        let uploadedImages = [];
        if (localStorage.getItem("uploaded_images")) {
          uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
        }

        if (uploadedImages.length > 0) {
          const img = uploadedImages.find((x) => x.id === data?.attachment);

          if (img) {
            item = {
              uid: img.id,
              name: img.name,
              url: img.url,
              status: "done",
            };
          } else {
            item = {
              uid: data?.attachment,
              name: data?.attachment?.name || "New File",
              url: data?.attachment?.url,
              status: "done",
            };
          }
        } else {
          item = {
            uid: data?.attachment,
            name: data?.attachment?.name || "New File",
            url: data?.attachment?.url,
            status: "done",
          };
        }
      }

      setFileList([item]);
    } else {
      setFileList([]);
    }
  }, [data?.attachment]);

  const handleSetName = (name) => {
    setData({ ...data, name });
  };

  const handleSetDegree = (degree) => {
    setData({ ...data, degree });
  };

  const handleSetWorkingUnit = (working_unit) => {
    setData({ ...data, working_unit });
  };

  const handleSetContent = (content) => {
    setData({ ...data, content });
  };

  const handleSetUrl = (url) => {
    setData({ ...data, url });
  };

  const handleChangeAttachment = (resFile) => {
    setData({
      ...data,
      attachment: resFile,
    });
  };

  const handleRemoveAttachment = (id) => {
    setData({
      ...data,
      attachment: null,
    });
  };

  return (
    <div>
      <TextInput
        label={t("str_full_name")}
        name="name"
        onChange={(e) => handleSetName(e.target.value)}
        value={data?.name || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_nominator_academic_rank_degree")}
      </Typography>
      <br />
      <DegreeSelect lang={t("str_lang")} value={data?.degree || ""} onChange={handleSetDegree} />
      <br />
      <br />
      <TextInput
        label={t("str_work_unit")}
        name="working_unit"
        onChange={(e) => handleSetWorkingUnit(e.target.value)}
        value={data?.working_unit || ""}
      />
      <br />
      <TextInput
        label={t("str_evaluation_content")}
        name="content"
        onChange={(e) => handleSetContent(e.target.value)}
        value={data?.content || ""}
      />
      <br />
      <TextInput
        label={t("str_link_to_proof")}
        name="url"
        onChange={(e) => handleSetUrl(e.target.value)}
        value={data?.url || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_or_and")}
      </Typography>
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        handleRemoveFile={handleRemoveAttachment}
        accept="application/pdf"
      />
    </div>
  );
};

export default ThesisMember;
